import DunzoStatementsContainer from "./DunzoStatementsContainer";

export default DunzoStatementsContainer;